import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(customParseFormat);

/**
 * Get full year
 * @param {string} input
 */
export const getFullYear = input => {
  input = input.toString();

  switch (input.length) {
    case 1:
      return dayjs(`0${input}`, "YY").format("YYYY");
    case 2:
      return dayjs(input, "YY").format("YYYY");
    default:
      return input;
  }
};

/**
 * Get timestamp for filename
 */
export const getFileStamp = () => dayjs().format("YYYY-MM-DD-H-MM");

/**
 * Get long date format
 * @param {string} timestamp
 */
export const getLongDate = timestamp =>
  dayjs.utc(timestamp).local().format("MMMM D, YYYY");

/**
 * Get time relative to current day
 * localized for the user's timezone
 * @param {string} timestamp
 */
export const getRelativeTime = timestamp => {
  const dateObj = dayjs.utc(timestamp).local();
  const relative = dateObj.isBefore(dayjs(), "day") ? "yesterday" : "today";
  const time = dateObj.format("h:mm A z");
  return `${relative} at ${time}`;
};

/**
 * Get short date format
 * @param {string} timestamp
 */
export const getShortDate = timestamp =>
  dayjs.utc(timestamp).local().format("MM/DD/YYYY");

/**
 * Get short date format from date string without timezone
 * @param {string} timestamp
 */
export const getShortDateNoTz = timestamp =>
  dayjs(timestamp).format("MM/DD/YYYY");

/**
 * Get shorter date format
 * @param {string} timestamp
 */
export const getShorterDate = timestamp =>
  dayjs.utc(timestamp).local().format("MM/DD/YY");

/**
 * Get short date timestamp
 * @param {string} timestamp
 */
export const getShortStamp = timestamp =>
  dayjs.utc(timestamp).local().format("MM-DD-YY @ h:mma");

/**
 * Get date timestamp
 * @param {string} timestamp
 */
export const getStamp = timestamp =>
  dayjs.utc(timestamp).local().format("MM/DD/YYYY @ hh:mm:ssa");

/**
 * Get date timestamp with moment format "LL" example (September 4, 2021)
 * @param {string} timestamp
 */
export const getFormattedDate = timestamp =>
  dayjs(timestamp).format("MMMM D, YYYY");

/**
 * Get date object from date string
 * @param {string} dateString
 * @returns {object}
 */
export const getDateObject = dateString =>
  dayjs
    .utc(dateString, ["YYYY-MM-DDTHH:mm:ss.SSSZ", "YYYY-MM-DD HH:mm:ss"])
    .local();
